module.exports = __webpack_public_path__ + "images/emails/statistics/background-bar-30eaa11a12c1ab7eeacca83c46119992.png";